<script>

import CartsForm from './CartsForm';

export default {
  props: ['replacefilters', 'changefilters', 'listing'],
  components: { CartsForm },
  data() {
    return {
      show_filters: false,
      changes: false,
      
      search: '',
      dateRange_payable: { startDate: null, endDate: null },
      dateRange_sent: { startDate: null, endDate: null },
      dateRange_due: { startDate: null, endDate: null },
      dateRange_paid: { startDate: null, endDate: null },
      dateRange: { startDate: null, endDate: null },
      status: [
        {id: '0', name: 'Void', active: true},
        {id: '1', name: 'Draft', active: true},
        {id: '2', name: 'Payable', active: true},
        {id: '3', name: 'Paid', active: true},
      ],
      invoice_types: [
        {id: 'Initial listing', name: 'Initial listing', active: true},
        {id: 'Upgrade listing', name: 'Upgrade listing', active: true},
        {id: 'Invoice', name: 'Invoice', active: true},
      ],
      payment_methods: [
        {id: 'Cash', name: 'Cash', active: true},
        {id: 'Check', name: 'Check', active: true},
        {id: 'Website client ', name: 'Website client', active: true},
        {id: 'Website admin', name: 'Website admin', active: true},
        {id: 'Stripe client', name: 'Stripe client', active: true},
        {id: 'Stripe admin', name: 'Stripe admin', active: true},
        {id: 'Other', name: 'Other', active: true},
      ],

      loading: true,
      results: [],
      pagination: {},
      filters: {
        paginate: 50,
        page: 1,
        total: 0,
        wheres: {},
        whereins: {
          website: [],
          status: [],
          invoice_type: [],
          payment_method: [],
        },
        betweens: {
          created_at: {
            start: '',
            end: ''
          }
        },
        searchs: {
          search1: {
            value: ''
          }
        },
        orderbys: {},
      },

      default_new_cart: {
        // id: '',
        // user_id: '',
        listing_id: '',
        status: 1,
        from_name: '',
        from_email: '',
        from_phone: '',
        from_address: '',
        from_city: '',
        from_state: '',
        from_zip_code: '',
        to_name: '',
        to_email: '',
        to_phone: '',
        to_address: '',
        to_city: '',
        to_state: '',
        to_zip_code: '',
        for_name: '',
        for_email: '',
        for_phone: '',
        for_address: '',
        for_city: '',
        for_state: '',
        for_zip_code: '',
        intro: 'Thank you for your business.',
        outro: 'We are here to answer any questions you might have. Please feel free to reach out by email, contact form, phone or chat.',
        package: {},
        services: [],
        sub_total: 0.00,
        discount_total: 0.00,
        total: 0.00,
        paid_total: 0.00,
        stripe_token: '',
        invoice_type: 'Invoice',
        payment_method: '',
        payment_method_other: '',
        send_count: 0,
        cart_hash: '',
        payable_date: '',
        first_issue_date: '',
        last_issue_date: '',
        due_date: '',
        paid_date: '',
      },
      edit_cart: {},
    }
  },
  watch: {
    'dateRange_payable': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.payable_date.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.payable_date.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.payable_date.start = '';
        this.filters.betweens.payable_date.end = '';
      }
    }},
    'dateRange_sent': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.first_issue_date.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.first_issue_date.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.first_issue_date.start = '';
        this.filters.betweens.first_issue_date.end = '';
      }
    }},
    'dateRange_due': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.due_date.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.due_date.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.due_date.start = '';
        this.filters.betweens.due_date.end = '';
      }
    }},
    'dateRange_paid': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.paid_date.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.paid_date.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.paid_date.start = '';
        this.filters.betweens.paid_date.end = '';
      }
    }},
    'dateRange': { handler: function(n, o) {
      if(n.startDate && n.endDate && this.moment(n.startDate).isValid() && this.moment(n.endDate).isValid()) {
        this.filters.betweens.created_at.start = this.moment(n.startDate).startOf('day').format();
        this.filters.betweens.created_at.end = this.moment(n.endDate).endOf('day').format();
      } else {
        this.filters.betweens.created_at.start = '';
        this.filters.betweens.created_at.end = '';
      }
    }, deep: true },

    'loading': { handler: function(n, o) { this.$emit('loadchange', n) }},

    'filters.paginate': { handler: function(n, o) { this.pagination.current_page = 1; this.fetchData(); }},
  },
  created() {
    if(this.replacefilters) {
      this.filters = this.replacefilters;
    } else if(this.changefilters) {
      for(var i in this.changefilters) {
        this.filters[i] = this.changefilters[i];
      }
    }

    if(this.listing.id) {
      this.filters.wheres.listing_id = this.listing.id;

      this.default_new_cart.listing_id = this.listing.id;
      this.default_new_cart.from_name = this.app_name;
      this.default_new_cart.from_email = this.app_email;
      this.default_new_cart.from_phone = this.app_phone;
      this.default_new_cart.from_address = this.app_address;
      this.default_new_cart.from_city = this.app_city;
      this.default_new_cart.from_state = this.app_state;
      this.default_new_cart.from_zip_code = this.app_zip_code;
      this.default_new_cart.to_name = (this.listing.user && this.listing.user.name ? this.listing.user.name : '');
      this.default_new_cart.to_email = (this.listing.user && this.listing.user.email ? this.listing.user.email : '');
      this.default_new_cart.to_phone = (this.listing.user && this.listing.user.phone ? this.listing.user.phone : '');
      this.default_new_cart.for_address = this.listing.Address;
      this.default_new_cart.for_city = this.listing.City;
      this.default_new_cart.for_state = this.listing.StateOrProvince;
      this.default_new_cart.for_zip_code = this.listing.PostalCode;
      this.edit_cart = JSON.parse(JSON.stringify(this.default_new_cart));
    }
    this.setWhereIns('status','filters','status');
    this.setWhereIns('invoice_types','filters','invoice_type');
    this.setWhereIns('payment_methods','filters','payment_method');
    this.fetchData();
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.filters.page = this.pagination.current_page;
      this.$http.get('/api/carts/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        this.results = res.data.data;
        this.pagination = res.data;
        this.filters.total = res.data.total;
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
    setWhereIns(items,filters,wherein) {
      var temp = [], all = true; for(var i in this[items]) { if(this[items][i].active) { temp.push(this[items][i].id); } else { all = false; } }

      var path = filters.split('.');
      var obj = this;
      for(var i in path) { obj = obj[path[i]]; }
      if(all) { obj.whereins[wherein] = ""; } else { obj.whereins[wherein] = temp; }
    },
    export_carts() {
      if(this.disabled == true) { this.$noty.warning('Disabled'); return; } this.disabled = true; this.loading = true;
      this.$http.get('/api/carts/export', {params: this.filters, responseType: 'arraybuffer'}).then(res => {
        // console.log(res);
        var newBlob = new Blob([res.data], {type: res.headers['content-type']});
        if(window.navigator && window.navigator.msSaveOrOpenBlob) { window.navigator.msSaveOrOpenBlob(newBlob); return; }
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a'); link.href = data; link.download = 'carts_export.csv'; link.click();
        setTimeout(function () { window.URL.revokeObjectURL(data) }, 100);
        this.disabled = false; this.loading = false;
      }).catch(res => { this.popupErrors(res); this.disabled = false; this.loading = false; });
    },
  }
}
</script>

<template>
  <div class="">
    <transition name="fade">
      <div class="ribbon-two ribbon-two-primary" :key="1" v-if="loading"><span><i class="spinner-border spinner-border-sm"></i></span></div>
    </transition>

    <b-modal ref="modal_cart" centered size="xl" title="Create a new cart" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
      <CartsForm :cart="edit_cart" :preload_listing="listing" @closemodal="$refs.modal_cart.hide()" @fetchdata="fetchData(); $emit('fetchdata')"></CartsForm>
    </b-modal>

    <div class="px-4 pt-4 pb-3">
      <div class="row">
        <div class="col-lg-8">
          <div class="form-inline">
            <button type="button" @click="fetchData()" class="btn btn-light mr-2 mb-2"><Icon icon="ri:refresh-line"></Icon></button>
            <div class="form-group mr-2 mb-2">
              <input type="text" class="form-control" placeholder="Search..." v-model="filters.searchs.search1.value" @change="changes = true">
            </div>
            <w-field class="mr-2 mb-2" SimpleDataType="String List, Multi" :Options="app_website_ids" v-model="filters.whereins.website" placeholder="Websites..." @input="changes = true"></w-field>
            <div class="form-group mr-2 mb-2">
              <button type="button" class="btn btn-primary dropdown-toggle" @click="show_filters ? show_filters = false : show_filters = true">Filters
                <Icon v-if="show_filters" icon="ri:arrow-drop-down-line"></Icon>
                <Icon v-else icon="ri:arrow-drop-right-line"></Icon>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-lg-right mt-3 mt-lg-0">
            <a v-if="listing.id && listing.user_id" @click="edit_cart = JSON.parse(JSON.stringify(default_new_cart)); $refs.modal_cart.show()" class="btn btn-success ml-2"><Icon icon="ri:add-line" /> Add New</a>
            <a v-else-if="listing.id && !listing.user_id" class="btn btn-success text-white ml-2" disabled><Icon icon="ri:add-line" /> No assigned user)</a>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="show_filters" class="form-inline px-2 pt-2 bg-gray-200">

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            Status: ({{status.filter(b=>{return b.active}).length}}/{{status.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in status" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('status','filters','status'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            Invoice type: ({{invoice_types.filter(b=>{return b.active}).length}}/{{invoice_types.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in invoice_types" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('invoice_types','filters','invoice_type'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2 position-relative">
          <button type="button" class="btn btn-white dropdown-toggle font-weight-500" data-toggle="dropdown">
            Payment method: ({{payment_methods.filter(b=>{return b.active}).length}}/{{payment_methods.length}})
            <Icon icon="ri:arrow-down-s-line" />
          </button>
          <div class="dropdown-menu dropdown-menu-right" onclick="event.stopPropagation()">
            <div v-for="(item, index) in payment_methods" :key="item.id" class="dropdown-item">
              <p-check class="p-default p-curve p-smooth pretty-light w-100" color="success-o" v-model="item.active" @change="setWhereIns('payment_methods','filters','payment_method'); changes = true"> <span class="ml-1">{{item.name}}</span></p-check>
            </div>
          </div>
        </div>

        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange_payable" placeholder="Filter by payable date..." @input="changes = true"></w-field>
        </div>
        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange_sent" placeholder="Filter by first sent date..." @input="changes = true"></w-field>
        </div>
        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange_due" placeholder="Filter by due date..." @input="changes = true"></w-field>
        </div>
        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange_paid" placeholder="Filter by paid date..." @input="changes = true"></w-field>
        </div>
        <div class="form-group mr-2 mb-2">
          <w-field SimpleDataType="Date range" v-model="dateRange" placeholder="Filter by date created..." @input="changes = true"></w-field>
        </div>

        <div class="form-group mr-2 mb-2">
          <select class="form-control" v-model="filters.paginate">
            <option value="50">Per page: (50)</option>
            <option value="100">Per page: (100)</option>
            <option value="250">Per page: (250)</option>
            <option value="500">Per page: (500)</option>
            <option value="750">Per page: (750)</option>
            <option value="1000">Per page: (1000)</option>
          </select>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="changes" class="alert alert-info rounded-0 m-0">Click <Icon icon="ri:refresh-line"></Icon> commit any changes made to filters.</div>
    </transition>
    <div class="row">
      <div class="col-sm-12">
        <div class="table-responsive m-0">
          <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
            <thead>
              <tr>
                <th><tdsort coltext="Cart status" :orderby.sync="filters.orderbys.status" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Bill from" :orderby.sync="filters.orderbys.from_name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Bill to" :orderby.sync="filters.orderbys.to_name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Bill for" :orderby.sync="filters.orderbys.for_address" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Order number" :orderby.sync="filters.orderbys.id" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Package" :orderby.sync="filters.orderbys.package" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Service(s)" :orderby.sync="filters.orderbys.services" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Subtotal" :orderby.sync="filters.orderbys.sub_total" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Discount total" :orderby.sync="filters.orderbys.discount_total" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Total" :orderby.sync="filters.orderbys.total" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Amount paid" :orderby.sync="filters.orderbys.paid_total" @do="fetchData()"></tdsort></th>
                <th>Amount due</th>
                <th><tdsort coltext="Invoice type" :orderby.sync="filters.orderbys.invoice_type" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Payment method" :orderby.sync="filters.orderbys.payment_method" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Sent count" :orderby.sync="filters.orderbys.send_count" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Payable date" :orderby.sync="filters.orderbys.payable_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="First sent date" :orderby.sync="filters.orderbys.first_issue_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last sent date" :orderby.sync="filters.orderbys.last_issue_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Due date" :orderby.sync="filters.orderbys.due_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Paid date" :orderby.sync="filters.orderbys.paid_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last updated" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
              <tr class="sticky-thead bg-white">
                <th><tdsort coltext="Cart status" :orderby.sync="filters.orderbys.status" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Website" :orderby.sync="filters.orderbys.website" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Bill from" :orderby.sync="filters.orderbys.from_name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Bill to" :orderby.sync="filters.orderbys.to_name" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Bill for" :orderby.sync="filters.orderbys.for_address" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Order number" :orderby.sync="filters.orderbys.id" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Package" :orderby.sync="filters.orderbys.package" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Service(s)" :orderby.sync="filters.orderbys.services" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Subtotal" :orderby.sync="filters.orderbys.sub_total" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Discount total" :orderby.sync="filters.orderbys.discount_total" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Total" :orderby.sync="filters.orderbys.total" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Amount paid" :orderby.sync="filters.orderbys.paid_total" @do="fetchData()"></tdsort></th>
                <th>Amount due</th>
                <th><tdsort coltext="Invoice type" :orderby.sync="filters.orderbys.invoice_type" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Payment method" :orderby.sync="filters.orderbys.payment_method" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Sent count" :orderby.sync="filters.orderbys.send_count" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Payable date" :orderby.sync="filters.orderbys.payable_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="First sent date" :orderby.sync="filters.orderbys.first_issue_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last sent date" :orderby.sync="filters.orderbys.last_issue_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Due date" :orderby.sync="filters.orderbys.due_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Paid date" :orderby.sync="filters.orderbys.paid_date" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Last updated" :orderby.sync="filters.orderbys.updated_at" @do="fetchData()"></tdsort></th>
                <th><tdsort coltext="Created on" :orderby.sync="filters.orderbys.created_at" @do="fetchData()"></tdsort></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in results" :key="item.id" @click="edit_cart = JSON.parse(JSON.stringify(item)); $refs.modal_cart.show()" class="_c-pointer">
                <td class="py-1">
                  <div class="alert text-white m-0 py-1" :class="
                    (item.status == 0 ? 'bg-danger' :
                    item.status == 1 ? 'bg-purple' :
                    item.status == 2 ? 'bg-warning' :
                    item.status == 3 ? 'bg-success' :
                    'bg-light')
                  ">
                    {{(item.status == 0 ? 'Void' :
                      item.status == 1 ? 'Draft' :
                      item.status == 2 ? 'Payable' :
                      item.status == 3 ? 'Paid' :
                      'Unknown')}}
                  </div>
                </td>
                <td>{{item.website}}</td>
                <td class="py-1">
                  <div class="text-dark font-weight-bold">{{item.from_name}}</div>
                  <div class="text-muted">{{item.from_email}}</div>
                  <div class="text-muted">{{formatPhone(item.from_phone)}}</div>
                </td>
                <td class="py-1">
                  <div class="text-dark font-weight-bold">{{item.to_name}}</div>
                  <div class="text-muted">{{item.to_email}}</div>
                  <div class="text-muted">{{formatPhone(item.to_phone)}}</div>
                </td>
                <td class="py-1">
                  <div class="text-dark font-weight-bold">{{item.for_address}}</div>
                  <div class="text-muted">{{item.for_city}}, {{item.for_state}} {{item.for_zip_code}}</div>
                </td>
                <td>{{item.id}}</td>
                <td>{{item.package.title}}</td>
                <td class="py-1">
                  <div v-for="(service, service_i) in item.services" :key="service_i+'s'+service.id">{{service.title}}</div>
                </td>
                <td>{{formatPrice(item.sub_total)}}</td>
                <td>{{item.discount_total > 0 ? '-'+formatPrice(item.discount_total) : '$0'}}</td>
                <td>{{formatPrice(item.total)}}</td>
                <td>{{formatPrice(item.paid_total)}}</td>
                <td>{{item.total && item.paid_total ? formatPrice(item.total - item.paid_total) : ''}}</td>
                <td>{{item.invoice_type}}</td>
                <td>{{item.payment_method}}<div v-if="item.payment_method && item.payment_method == 'Other'"> : {{item.payment_method_other}}</div></td>
                <td>{{item.send_count}}</td>
                <td><div v-if="item.payable_date" v-tippy :content="moment(item.payable_date).format('lll')">{{moment(item.payable_date).format('MM-DD-YYYY')}}</div></td>
                <td><div v-if="item.first_issue_date" v-tippy :content="moment(item.first_issue_date).format('lll')">{{moment(item.first_issue_date).format('MM-DD-YYYY')}}</div></td>
                <td><div v-if="item.last_issue_date" v-tippy :content="moment(item.last_issue_date).format('lll')">{{moment(item.last_issue_date).format('MM-DD-YYYY')}}</div></td>
                <td><div v-if="item.due_date" v-tippy :content="moment(item.due_date).format('MM-DD-YYYY')">{{moment(item.due_date).format('MM-DD-YYYY')}}</div></td>
                <td><div v-if="item.paid_date" v-tippy :content="moment(item.paid_date).format('lll')">{{moment(item.paid_date).format('MM-DD-YYYY')}}</div></td>
                <td v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td>
                <td v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="p-3 border-top border-light">
          <w-pagination :pagination="pagination" @paginate="fetchData()" :offset="4"></w-pagination>
        </div>
      </div>
    </div>
  </div>

</template>
